import CourtesyWorkBook from './CourtesyWorkBook';
import CongressionalWorkBook from './CongressionalWorkBook';
import SelectionForPanelsWorkBook from './SelectionForPanelsWorkBook';
import GenericWorkBook from './GenericWorkBook';

export default {
  courtesy: CourtesyWorkBook,
  congressionalNotification: CongressionalWorkBook,
  selectionForPanels: SelectionForPanelsWorkBook,
  genericWorkBook: GenericWorkBook,
};
